import { JSX } from 'react'

import * as detective from '@/lib/detective.js'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/ui/layout.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Navigate from '@/components/ui/navigate.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Breadcrumb from '@/components/ui/breadcrumb.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Headerx from '@/components/ui/header.tsx'




export type Options = Navigate.TOptions


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Root
(
	props: {
		options: Options

	},

)
:	JSX.Element
{
	return (
		<Layout.Root>
			<Navigate.Root>
				<Navigate.Options value={props.options} />

			</Navigate.Root>

		</Layout.Root>

	)

}


// eslint-disable-next-line @typescript-eslint/naming-convention
export function Header
(
	props: {
		breadcrumb: string[]
		options?  : string[]
		change?(v: string): void
	},

)
:	JSX.Element
{
	let segment = <></>

	if (detective.is_array(props.options) && props.options.length > 0)
	{
		let on_change = (v: string): void =>
		{
			props.change?.(v)

		}

		segment = <Headerx.Segment options={props.options} change={on_change} />

	}

	return (
		<Headerx.Root breadcrumb={<Breadcrumb.Root value={props.breadcrumb} />}>
			{segment}

		</Headerx.Root>

	)


}


export { Alive } from '@/components/ui/layout.tsx'

export { Root as Main } from '@/components/ui/main.tsx'

export { scroll_styles, Scroll } from '@/components/ui/main.tsx'

export { Search, Filter, Toolbar, Section } from '@/components/ui/main.tsx'

